import React from 'react';
import styled from 'styled-components';

const UPDATES = [
  { kb: 'KB5034441', title: 'Security Update for Microsoft 365 Apps', severity: 'Critical', size: '48.2 MB', date: '2024-12-10' },
  { kb: 'KB5035845', title: 'Patch for CVE-2024-21413 (Outlook Remote Code Execution)', severity: 'Critical', size: '12.7 MB', date: '2024-11-14' },
  { kb: 'KB5034763', title: 'Cumulative Security Update for Internet Explorer', severity: 'Critical', size: '8.3 MB', date: '2024-10-08' },
  { kb: 'KB5033372', title: 'Microsoft Defender Definition Update v1.403', severity: 'Critical', size: '14.1 MB', date: '2024-09-22' },
  { kb: 'KB5031356', title: 'Windows Malicious Software Removal Tool - March 2025', severity: 'Important', size: '6.8 MB', date: '2025-03-11' },
  { kb: 'KB5029244', title: '.NET Framework 4.8.1 Security Update', severity: 'Important', size: '22.4 MB', date: '2024-08-15' },
  { kb: 'KB5028185', title: 'Security Update for Windows XP (SMB Vulnerability)', severity: 'Critical', size: '3.2 MB', date: '2024-07-20' },
  { kb: 'KB5027231', title: 'Firmware Update for Dell OptiPlex 7050', severity: 'Recommended', size: '1.8 MB', date: '2024-06-30' },
  { kb: 'KB5026361', title: 'Adobe Flash Player Removal Update', severity: 'Important', size: '0.9 MB', date: '2024-05-12' },
  { kb: 'KB5025221', title: 'Exchange Server Cumulative Security Update', severity: 'Critical', size: '105.3 MB', date: '2024-04-08' },
  { kb: 'KB5024542', title: 'Windows Kernel Security Patch (Privilege Escalation)', severity: 'Critical', size: '5.6 MB', date: '2024-03-19' },
  { kb: 'KB5023698', title: 'Print Spooler Remote Code Execution Fix', severity: 'Critical', size: '2.1 MB', date: '2024-02-14' },
  { kb: 'KB5022845', title: 'SSL/TLS Certificate Validation Update', severity: 'Important', size: '1.3 MB', date: '2024-01-22' },
  { kb: 'KB5021255', title: 'Remote Desktop Protocol Security Update', severity: 'Critical', size: '4.7 MB', date: '2023-12-11' },
  { kb: 'KB5020438', title: 'Microsoft Office Security Update', severity: 'Important', size: '31.2 MB', date: '2023-11-15' },
];

function WindowsUpdate({ onClose }) {
  const criticalCount = UPDATES.filter(u => u.severity === 'Critical').length;
  const importantCount = UPDATES.filter(u => u.severity === 'Important').length;
  const totalSize = '847.3 MB';

  return (
    <Div>
      {/* Blue WU header */}
      <div className="wu__header">
        <div className="wu__header__left">
          <div className="wu__header__logo">
            <svg viewBox="0 0 32 32" width="32" height="32">
              <rect x="1" y="1" width="13" height="13" rx="2" fill="#ff6611" />
              <rect x="17" y="1" width="13" height="13" rx="2" fill="#33bb33" />
              <rect x="1" y="17" width="13" height="13" rx="2" fill="#3388dd" />
              <rect x="17" y="17" width="13" height="13" rx="2" fill="#ffcc00" />
            </svg>
          </div>
          <div>
            <div className="wu__header__title">Windows Update</div>
            <div className="wu__header__sub">Keep your computer up to date</div>
          </div>
        </div>
      </div>

      <div className="wu__body">
        {/* Left nav */}
        <div className="wu__nav">
          <div className="wu__nav__item wu__nav__item--active">Welcome</div>
          <div className="wu__nav__item">Pick updates to install</div>
          <div className="wu__nav__item">Review and install updates</div>
          <div className="wu__nav__sep" />
          <div className="wu__nav__item">View installation history</div>
          <div className="wu__nav__item">Personalise Windows Update</div>
          <div className="wu__nav__item">Get help and related links</div>
        </div>

        {/* Main content */}
        <div className="wu__main">
          {/* Warning banner */}
          <div className="wu__warning">
            <div className="wu__warning__shield">!</div>
            <div className="wu__warning__text">
              <strong>Updates are ready for your computer</strong><br />
              Last successful check for updates: <span className="wu__red">14 March 2022 — over 3 years ago</span>
            </div>
          </div>

          {/* Stats boxes */}
          <div className="wu__stats">
            <div className="wu__stat wu__stat--critical" title="Critical updates should be installed immediately">
              <div className="wu__stat__icon">⊗</div>
              <div>
                <div className="wu__stat__count">{criticalCount}</div>
                <div>critical updates available</div>
              </div>
            </div>
            <div className="wu__stat wu__stat--important">
              <div className="wu__stat__icon">⚠</div>
              <div>
                <div className="wu__stat__count">{importantCount}</div>
                <div>important updates available</div>
              </div>
            </div>
          </div>

          <div className="wu__total">
            Total updates available: <strong>847</strong> (Download size: {totalSize})
          </div>

          {/* Update list */}
          <div className="wu__list">
            <div className="wu__list__header">
              <span className="wu__col wu__col--check"></span>
              <span className="wu__col wu__col--sev">Severity</span>
              <span className="wu__col wu__col--title">Update</span>
              <span className="wu__col wu__col--size">Size</span>
              <span className="wu__col wu__col--date">Date</span>
            </div>
            {UPDATES.map((upd, i) => (
              <div key={i} className={`wu__list__row ${i % 2 === 0 ? 'wu__list__row--alt' : ''}`}>
                <span className="wu__col wu__col--check">
                  <input type="checkbox" checked disabled />
                </span>
                <span className={`wu__col wu__col--sev wu__sev--${upd.severity.toLowerCase()}`}>
                  {upd.severity}
                </span>
                <span className="wu__col wu__col--title">{upd.title}</span>
                <span className="wu__col wu__col--size">{upd.size}</span>
                <span className="wu__col wu__col--date">{upd.date}</span>
              </div>
            ))}
            <div className="wu__list__more">... and 832 more updates not shown</div>
          </div>

          {/* Action bar */}
          <div className="wu__actions">
            <button className="wu__btn wu__btn--disabled" disabled>Express Install (Recommended)</button>
            <button className="wu__btn wu__btn--disabled" disabled>Custom Install</button>
          </div>

          {/* CTA */}
          <div className="wu__cta">
            <div className="wu__cta__text">
              <strong>Your IT should be handling this.</strong> 847 updates since 2022 means nobody is managing your patches. That's a data breach waiting to happen.
            </div>
            <div className="wu__cta__contact">
              <strong>Dead Simple Computing</strong> — Managed IT & Patch Management &nbsp;|&nbsp; <strong className="wu__cta__phone">0118 359 2220</strong> &nbsp;|&nbsp; deadsimplecomputing.co.uk
            </div>
          </div>
        </div>
      </div>
    </Div>
  );
}

const Div = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  background: #ece9d8;
  font-family: Tahoma, 'Segoe UI', sans-serif;
  font-size: 11px;
  color: #000;

  /* Blue header bar */
  .wu__header {
    background: linear-gradient(to bottom, #4b84d8, #2955a5);
    padding: 10px 16px;
    display: flex;
    align-items: center;
  }
  .wu__header__left {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .wu__header__logo {
    flex-shrink: 0;
  }
  .wu__header__title {
    font-size: 18px;
    font-weight: bold;
    color: #fff;
    text-shadow: 0 1px 2px rgba(0,0,0,0.3);
  }
  .wu__header__sub {
    font-size: 11px;
    color: #c0d8ff;
  }

  /* Body layout */
  .wu__body {
    flex: 1;
    display: flex;
    overflow: hidden;
  }

  /* Left nav */
  .wu__nav {
    width: 170px;
    background: linear-gradient(to bottom, #7ba0d4, #4b70a8);
    padding: 12px 0;
    flex-shrink: 0;
  }
  .wu__nav__item {
    padding: 6px 14px;
    color: #c0d8ff;
    font-size: 11px;
    cursor: pointer;
    &:hover { color: #fff; background: rgba(255,255,255,0.1); }
  }
  .wu__nav__item--active {
    color: #fff;
    font-weight: bold;
    background: rgba(255,255,255,0.15);
    border-left: 3px solid #ffcc00;
    padding-left: 11px;
  }
  .wu__nav__sep {
    height: 1px;
    background: rgba(255,255,255,0.2);
    margin: 8px 14px;
  }

  /* Main content */
  .wu__main {
    flex: 1;
    background: #fff;
    padding: 12px 16px;
    overflow-y: auto;
  }

  /* Warning banner */
  .wu__warning {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    background: linear-gradient(to bottom, #fff3cc, #ffe899);
    border: 1px solid #d4a800;
    border-radius: 3px;
    padding: 10px 14px;
    margin-bottom: 12px;
  }
  .wu__warning__shield {
    width: 28px;
    height: 28px;
    background: #d4a800;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    flex-shrink: 0;
  }
  .wu__warning__text {
    font-size: 11px;
    line-height: 1.5;
    color: #333;
  }
  .wu__red { color: #cc0000; font-weight: bold; }

  /* Stats */
  .wu__stats {
    display: flex;
    gap: 12px;
    margin-bottom: 8px;
  }
  .wu__stat {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    border-radius: 4px;
    cursor: pointer;
  }
  .wu__stat--critical {
    background: linear-gradient(to bottom, #ffd0d0, #ffb0b0);
    border: 1px solid #cc6666;
  }
  .wu__stat--important {
    background: linear-gradient(to bottom, #fff0cc, #ffe099);
    border: 1px solid #cc9933;
  }
  .wu__stat__icon {
    font-size: 20px;
    color: #cc0000;
  }
  .wu__stat--important .wu__stat__icon {
    color: #cc6600;
  }
  .wu__stat__count {
    font-size: 22px;
    font-weight: bold;
    line-height: 1;
  }
  .wu__stat--critical .wu__stat__count { color: #cc0000; }
  .wu__stat--important .wu__stat__count { color: #cc6600; }

  .wu__total {
    font-size: 11px;
    color: #666;
    margin-bottom: 10px;
    padding: 4px 0;
    border-bottom: 1px solid #e0e0e0;
  }

  /* Update list */
  .wu__list {
    border: 1px solid #7f9db9;
    margin-bottom: 8px;
  }
  .wu__list__header {
    display: flex;
    background: linear-gradient(to bottom, #f0f0ea, #d8d8d0);
    border-bottom: 1px solid #aaa;
    padding: 3px 4px;
    font-weight: bold;
    font-size: 10px;
    position: sticky;
    top: 0;
  }
  .wu__list__row {
    display: flex;
    padding: 3px 4px;
    border-bottom: 1px solid #f0f0f0;
    font-size: 10px;
    &:hover { background: #d8e8ff; }
  }
  .wu__list__row--alt {
    background: #f8f8f5;
  }
  .wu__col--check { width: 22px; flex-shrink: 0; }
  .wu__col--sev { width: 65px; flex-shrink: 0; font-size: 9px; font-weight: bold; }
  .wu__col--title { flex: 1; }
  .wu__col--size { width: 60px; flex-shrink: 0; color: #666; text-align: right; }
  .wu__col--date { width: 75px; flex-shrink: 0; color: #666; padding-left: 8px; }
  .wu__sev--critical { color: #cc0000; }
  .wu__sev--important { color: #cc6600; }
  .wu__sev--recommended { color: #006600; }
  .wu__list__more {
    padding: 6px;
    text-align: center;
    color: #999;
    font-style: italic;
    font-size: 10px;
  }

  /* Action buttons */
  .wu__actions {
    display: flex;
    gap: 8px;
    margin-bottom: 10px;
  }
  .wu__btn {
    padding: 5px 16px;
    background: linear-gradient(to bottom, #fff, #e3e3d8);
    border: 1px solid #999;
    border-radius: 2px;
    font-family: Tahoma, sans-serif;
    font-size: 11px;
    cursor: pointer;
    &:hover { background: linear-gradient(to bottom, #fff, #d0d0c8); }
  }
  .wu__btn--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* CTA */
  .wu__cta {
    background: linear-gradient(to bottom, #f5f5f0, #e8e8e0);
    border: 1px solid #c0c0b0;
    border-radius: 3px;
    padding: 10px 14px;
  }
  .wu__cta__text {
    font-size: 11px;
    color: #333;
    margin-bottom: 4px;
    line-height: 1.5;
  }
  .wu__cta__contact {
    font-size: 11px;
    color: #003399;
  }
  .wu__cta__phone {
    color: #003399;
    font-size: 13px;
  }
`;

export default WindowsUpdate;
